import React, { useState } from "react";
import Highlighter from "react-highlight-words";
import { CalculateQuantity } from "../JobEnquiry/ListDataProjectJobEnquiry";
import { AiOutlineCloudDownload } from "react-icons/ai";
import JobOrderDownloadPupup from "./JobOrderDownloadPupup";
import sectionTableReport from "../excel/SectionTableReport";
import SearchFilter from "../../../../../../components/SmartDataTable/SearchFilter";
import PaginationControls from "../../../../../../components/SmartDataTable/PaginationControls";

const InitialSelectedTItles = [
  { col: "Actual Profession", title: "actual_profession" },
  { col: "Visa Profession", title: "visa_profession" },
  { col: "Profession Level", title: "profession_level" },
  { col: "Gender", title: "gender" },
  { col: "Nationality", title: "nationality" },
  { col: "Quantity", title: "quantity" },
  { col: "Total Monthly Per Head Cost", title: "total_monthly_cost_head" },
];

const PAGE_SIZE_OPTIONS = [10, 25, 50, 100];

export default function ListDataJobOrder({ jobOrderData, loading, titles }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchWords, setSearchWords] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const [downloadPopupState, setDownloadPopupState] = useState({ open: false, rowId: null, data: "" });

  const allData = jobOrderData?.job_order_list || [];

  const filtered = searchTerm.trim()
    ? allData.filter((item) =>
        String(item?.job_order_number ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item?.job_enquiry_recruitment_agency?.job_enquiry_number ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item?.job_enquiry_recruitment_agency?.vendor?.name ?? "").toLowerCase().includes(searchTerm.toLowerCase()) ||
        String(item?.nationality?.name ?? "").toLowerCase().includes(searchTerm.toLowerCase())
      )
    : allData;

  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const safePage = Math.min(currentPage, totalPages);
  const pageData = filtered.slice((safePage - 1) * pageSize, safePage * pageSize);

  const handleSearchChange = (val) => {
    setSearchTerm(val);
    setSearchWords(val ? val.trim().split(/\s+/) : []);
    setCurrentPage(1);
  };

  const reportHeadings = [
    { title: "JOB ENQUIRY NO", key: "job_order_number" },
    { title: "REC. AGENCY JOB ENQ NO", key: "job_enquiry_recruitment_agency.job_enquiry_number" },
    { title: "NATIONALITY", key: "nationality.name" },
    { title: "TOTAL QUANTITY", key: "project_job_order_cost_sheet_profession_basic_information", type: "function", function: CalculateQuantity },
    { title: "JOB ASSIGNED TO", key: "job_enquiry_recruitment_agency.vendor.name" },
  ];

  const HL = ({ text }) => <Highlighter searchWords={searchWords} autoEscape textToHighlight={text || "-"} />;

  return (
    <>
      {downloadPopupState.open && (
        <JobOrderDownloadPupup
          InitialSelectedTItles={InitialSelectedTItles}
          openGenerateQuotation={downloadPopupState}
          setOpenGenerateQuotation={setDownloadPopupState}
          jobOrderData={jobOrderData}
          data={downloadPopupState.data}
        />
      )}

      {/* Toolbar */}
      <div className="flex flex-wrap gap-2 items-center w-full mb-4 flex-row-reverse">
        <SearchFilter searchTerm={searchTerm} onSearchChange={handleSearchChange} placeholder="Search across all columns..." />
        <div className="flex gap-2 items-center">
          <button className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm" onClick={() => sectionTableReport(filtered, reportHeadings, "Job Order Report")}>
            Download
          </button>
        </div>
      </div>

      <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block">{`Slide / scroll to right >`}</p>

      {/* Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow max-h-[70vh]">
        <table className="min-w-full">
          <thead className="bg-gray-50 sticky top-0 z-20 shadow-sm">
            <tr className="bg-gray-50">
              {titles?.map((title, i) => (
                <th key={i} className="px-6 py-4 text-left text-base font-semibold text-gray-700 uppercase tracking-wider bg-gray-50" style={{ backgroundColor: '#f9fafb' }}>
                  {title}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white">
            {loading ? (
              <tr>
                <td colSpan={titles?.length || 7} className="px-6 py-8 text-center">
                  <div className="flex items-center justify-center">
                    <span className="loading loading-spinner loading-md mr-2"></span>
                    Loading data...
                  </div>
                </td>
              </tr>
            ) : pageData.length === 0 ? (
              <tr><td colSpan={titles?.length || 7} className="px-6 py-8 text-center text-gray-500">{searchTerm ? `No results found for "${searchTerm}"` : "No Job Order added."}</td></tr>
            ) : (
              pageData.map((list, index) => (
                <tr key={list.id ?? index} className="border-b-[1.5px] border-slate-100 hover:bg-gray-50">
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">{(safePage - 1) * pageSize + index + 1}</td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700"><HL text={list?.job_order_number} /></td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700"><HL text={list?.job_enquiry_recruitment_agency?.job_enquiry_number} /></td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700"><HL text={list?.nationality?.name} /></td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700 font-medium">
                    {CalculateQuantity(list?.project_job_order_cost_sheet_profession_basic_information)}
                  </td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700"><HL text={list?.job_enquiry_recruitment_agency?.vendor?.name} /></td>
                  <td className="px-6 py-6 whitespace-nowrap text-base text-gray-700">
                    <button onClick={() => setDownloadPopupState({ open: true, rowId: list?.id, data: list })} className="p-1 px-2 rounded-md ring-1 ring-slate-600" title="Download">
                      <AiOutlineCloudDownload size="1.4rem" />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <PaginationControls currentPage={safePage} totalPages={totalPages} pageSize={pageSize} totalRecords={filtered.length} pageSizeOptions={PAGE_SIZE_OPTIONS} onPageChange={(p) => setCurrentPage(p)} onPageSizeChange={(s) => { setPageSize(s); setCurrentPage(1); }} isLoading={loading} />
    </>
  );
}
